import DeleteIcon from '../DeleteIcon';
import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './ElementsLibrary.css';

const ElementsLibrary = ({ onAddElement }) => {
    const [library, setLibrary] = useState([]);
    const [showUpload, setShowUpload] = useState(false);
    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        loadLibrary();
    }, []);

    const loadLibrary = async () => {
        try {
            const res = await api.get('/maquetes/elements-library');
            setLibrary(res.data);
        } catch (error) {
            console.error('Erro ao carregar biblioteca:', error);
        }
    };

    const handleDragStart = (e, element) => {
        e.dataTransfer.setData('element', JSON.stringify(element));
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        setUploading(true);

        try {
            await api.post('/maquetes/assets/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            await loadLibrary();
            setShowUpload(false);
            e.target.reset();
            alert('Asset adicionado com sucesso!');
        } catch (error) {
            console.error('Erro ao adicionar asset:', error);
            alert('Erro ao adicionar asset');
        } finally {
            setUploading(false);
        }
    };
    const handleDeleteAsset = async (e, assetId) => {
        e.stopPropagation();
        if (!window.confirm('Apagar este asset da biblioteca permanentemente?')) return;

        try {
            await api.delete(`/maquetes/assets/${assetId}`);
            await loadLibrary();
        } catch (error) {
            console.error('Erro ao apagar asset:', error);
            alert('Erro ao apagar asset');
        }
    };

    return (
        <div className="elements-library">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <h3>Elementos</h3>
                <button
                    onClick={() => setShowUpload(!showUpload)}
                    className="btn-add-asset-toggle"
                    style={{
                        background: showUpload ? '#e53e3e' : '#48bb78',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        padding: '4px 8px',
                        cursor: 'pointer',
                        fontSize: '0.75em',
                        fontWeight: '700'
                    }}
                >
                    {showUpload ? '✕ Cancelar' : '+ Novo Asset'}
                </button>
            </div>

            {showUpload && (
                <form onSubmit={handleUpload} style={{
                    background: '#f8fafc',
                    padding: '10px',
                    borderRadius: '8px',
                    marginBottom: '15px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '8px', marginBottom: '8px' }}>
                        <input
                            type="text"
                            name="name"
                            placeholder="Nome"
                            required
                            style={{ width: '100%', padding: '5px 8px', borderRadius: '4px', border: '1px solid #cbd5e0', fontSize: '0.85em' }}
                        />
                        <input
                            type="text"
                            name="icon"
                            placeholder="🔴"
                            style={{ width: '100%', padding: '5px 8px', borderRadius: '4px', border: '1px solid #cbd5e0', fontSize: '0.85em', textAlign: 'center' }}
                        />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                        <input
                            type="file"
                            name="asset"
                            id="asset-file-input"
                            accept="image/*"
                            required
                            style={{ display: 'none' }}
                            onChange={(e) => {
                                const fileName = e.target.files[0]?.name;
                                const label = document.getElementById('asset-file-label');
                                if (label) label.textContent = fileName || 'Escolher ficheiro';
                            }}
                        />
                        <label
                            htmlFor="asset-file-input"
                            id="asset-file-label"
                            style={{
                                display: 'block',
                                padding: '6px',
                                background: 'white',
                                border: '1px dashed #cbd5e0',
                                borderRadius: '4px',
                                fontSize: '0.75em',
                                textAlign: 'center',
                                cursor: 'pointer'
                            }}
                        >
                            Escolher ficheiro
                        </label>
                    </div>
                    <button
                        type="submit"
                        disabled={uploading}
                        style={{
                            width: '100%',
                            background: '#4299e1',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            padding: '6px',
                            cursor: 'pointer',
                            fontWeight: '600',
                            fontSize: '0.85em'
                        }}
                    >
                        {uploading ? 'Enviando...' : 'Gravar Asset'}
                    </button>
                </form>
            )}

            <div className="library-items">
                {library.map(el => (
                    <div
                        key={el.id}
                        className="library-item"
                        draggable
                        onDragStart={(e) => handleDragStart(e, el)}
                        onClick={() => onAddElement(el)}
                        title={el.name}
                    >
                        {el.asset_id && (
                            <button
                                className="btn-delete-asset"
                                onClick={(e) => handleDeleteAsset(e, el.asset_id)}
                                title="Remover da biblioteca"
                            ><DeleteIcon /></button>
                        )}
                        <span className="library-icon">{el.icon}</span>
                        <span className="library-name">{el.name}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ElementsLibrary;
